import { bscTestnet } from "wagmi/chains";
import { useAccount, useContractWrite, useNetwork } from "wagmi";

import { NFT_CONTRACT } from "../config";
import abi from "../contracts/hermes.abi.json";

export const useNFTContract = () => {
  const { address } = useAccount();
  const { chain } = useNetwork();
  const contract = NFT_CONTRACT[chain?.id] || NFT_CONTRACT[bscTestnet.chainId];

  const { isLoading, writeAsync, ...others } = useContractWrite({
    abi,
    args: [address],
    functionName: "mint",
    address: contract,
  });

  return {
    isLoading,
    writeAsync,
    ...others,
  };
};
